(function () {
  var MOBILE = '(max-width: 749px)';
  var DURATION = 300;

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE).matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animate(card, body, startHeight, endHeight, onDone) {
    card.classList.add('et-lp-timeline__card--animating');
    body.style.overflow = 'hidden';
    body.style.height = startHeight + 'px';
    void body.offsetHeight;
    body.style.transition = 'height ' + DURATION + 'ms ease';
    body.style.height = endHeight + 'px';

    function end(event) {
      if (event && event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', end);
      body.style.transition = '';
      body.style.height = '';
      body.style.overflow = '';
      card.classList.remove('et-lp-timeline__card--animating');
      if (onDone) onDone();
    }

    body.addEventListener('transitionend', end);
  }

  function toggle(card) {
    if (card.classList.contains('et-lp-timeline__card--animating')) return;

    var body = card.querySelector('.et-lp-timeline__body');
    var badge = card.querySelector('.et-lp-timeline__badge');
    var isOpen = card.classList.contains('is-open');

    if (isOpen) {
      badge.setAttribute('aria-expanded', 'false');
      if (prefersReducedMotion()) {
        card.classList.remove('is-open');
      } else {
        animate(card, body, body.scrollHeight, 0, function () {
          card.classList.remove('is-open');
        });
      }
    } else {
      card.classList.add('is-open');
      badge.setAttribute('aria-expanded', 'true');
      if (!prefersReducedMotion()) {
        animate(card, body, 0, body.scrollHeight, null);
      }
    }
  }

  function syncState(section) {
    var cards = section.querySelectorAll('.et-lp-timeline__card');
    cards.forEach(function (card, index) {
      var badge = card.querySelector('.et-lp-timeline__badge');
      if (isMobile()) {
        var open = index === 0;
        card.classList.toggle('is-open', open);
        if (badge) badge.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else {
        /* Desktop: every card is expanded (CSS shows the body regardless). */
        card.classList.add('is-open');
        if (badge) badge.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initSection(section) {
    if (section.dataset.etTimelineReady) return;
    section.dataset.etTimelineReady = 'true';

    section.querySelectorAll('.et-lp-timeline__badge').forEach(function (badge) {
      badge.addEventListener('click', function () {
        if (!isMobile()) return;
        toggle(badge.closest('.et-lp-timeline__card'));
      });
    });

    syncState(section);

    if (window.matchMedia) {
      window.matchMedia(MOBILE).addEventListener('change', function () {
        syncState(section);
      });
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.et-lp-timeline').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
